import { ApplicationConfig, importProvidersFrom, inject, provideEnvironmentInitializer } from '@angular/core';

//import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';
import { authInterceptor } from './interceptors/auth.interceptor';
import { TgSettingsService } from './services/TG-Setting_Services/tg-settings.service';
import { TRANSLATION_CONFIG } from './services/Translate_Services/translation-config.token';
import { TranslationInitService } from './services/Translate_Services/translation-init.service';

const DEFAULT_LANG = 'en-GB';
const TRANSLATION_PREFIX = '/TGNewUI/NG-Widgets/browser/assets/i18n/GlobalResources.';
const TRANSLATION_SUFFIX = '.json';

function initializeAppFactory() {
  const tgSettingsService = inject(TgSettingsService);
  const translate = inject(TranslateService);
  const translationInit = inject(TranslationInitService);

  return async () => {
    try {
      await firstValueFrom(tgSettingsService.getSettings());
    } catch (err) {
      console.error('[Bootstrap Init] Initialization failed → fallback to en-GB', err);
      await firstValueFrom(translate.use(DEFAULT_LANG));
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor]), withFetch()),
    provideTranslateService(),
    provideTranslateHttpLoader({
      prefix: TRANSLATION_PREFIX,
      suffix: TRANSLATION_SUFFIX
    }),
    {
      provide: TRANSLATION_CONFIG,
      useValue: {
        prefix: TRANSLATION_PREFIX,
        suffix: TRANSLATION_SUFFIX
      }
    },
    provideEnvironmentInitializer(initializeAppFactory),
    importProvidersFrom(MatDatepickerModule, MatNativeDateModule)
  ]
};
